interface CategoryPillProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function CategoryPill({ label, isActive, onClick }: CategoryPillProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={isActive}
      onClick={onClick}
      className={[
        "flex-1 inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium transition-all duration-200",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#003366]",
        isActive
          ? "bg-[#003366] text-white shadow-sm"
          : "bg-slate-200/60 text-slate-700 hover:bg-slate-300",
      ].join(" ")}
    >
      {label}
    </button>
  );
}
